import { render, staticRenderFns } from "./curriculum.vue?vue&type=template&id=2997d46b&scoped=true&"
import script from "./curriculum.vue?vue&type=script&lang=js&"
export * from "./curriculum.vue?vue&type=script&lang=js&"
import style0 from "./curriculum.vue?vue&type=style&index=0&id=2997d46b&prod&lang=css&"
import style1 from "./curriculum.vue?vue&type=style&index=1&id=2997d46b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2997d46b",
  null
  
)

export default component.exports